import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { db } from '../config/firebase';

const ENQUIRIES_COLLECTION = 'enquiries';

/**
 * Saves an enquiry to Firebase Firestore.
 * @param {Object} data - Enquiry data (type, and type-specific fields)
 * @returns {Promise<{ ok: boolean, id?: string, error?: string }>}
 */
export async function saveEnquiry(data) {
  if (!db) {
    const msg = 'Firebase not configured — add .env and restart the dev server.';
    console.error('[Enquiry]', msg);
    return { ok: false, error: msg };
  }
  try {
    const docRef = await db.collection(ENQUIRIES_COLLECTION).add({
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
    return { ok: true, id: docRef.id };
  } catch (err) {
    const msg = err?.message || String(err);
    console.error('[Enquiry] Save failed:', msg, err?.code);
    return { ok: false, error: msg };
  }
}
